// // src/app/modules/Auth/pages/Activation.jsx
// import React, { useState, useRef, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { injectIntl } from "react-intl";
// import * as auth from "../_redux/authRedux";
// import { verifyEmail, sendVerificationEmail, getUserByToken } from "../_redux/authCrud";
// import './auth.scss';
// import { Mail, ArrowLeft } from 'lucide-react';
// import { useNavigate, useLocation } from 'react-router-dom';

// function Activation(props) {
//   const { intl } = props;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [loading, setLoading] = useState(false);
//   const [resending, setResending] = useState(false);
//   const [status, setStatus] = useState('');
//   const [code, setCode] = useState(['', '', '', '', '', '']);
//   const inputRefs = useRef([]);

//   const { email } = location.state || {};

//   useEffect(() => {
//     if (!email) {
//       console.log('❌ No email found, redirecting to login');
//       navigate('/auth/login');
//     } else {
//       console.log('📧 Activation email:', email);
//     }
//   }, [email, navigate]);

//   const handleCodeChange = (index, value) => {
//     if (!/^\d*$/.test(value)) return;

//     const newCode = [...code];
//     newCode[index] = value;
//     setCode(newCode);

//     if (value && index < 5 && inputRefs.current[index + 1]) {
//       inputRefs.current[index + 1].focus();
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === 'Backspace' && !code[index] && index > 0 && inputRefs.current[index - 1]) {
//       inputRefs.current[index - 1].focus();
//     }
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pastedData = e.clipboardData.getData('text').slice(0, 6);
//     if (!/^\d+$/.test(pastedData)) return;

//     const newCode = pastedData.split('');
//     while (newCode.length < 6) newCode.push('');
//     setCode(newCode);

//     const nextEmptyIndex = newCode.findIndex(c => !c);
//     const focusIndex = nextEmptyIndex === -1 ? 5 : nextEmptyIndex;
//     if (inputRefs.current[focusIndex]) {
//       inputRefs.current[focusIndex].focus();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const fullCode = code.join('');

//     if (fullCode.length !== 6) {
//       setStatus('Please enter the complete 6-digit code');
//       return;
//     }

//     setLoading(true);
//     setStatus('');

//     try {
//       console.log('🔐 Verifying code:', fullCode);
      
//       const body = {
//         code: fullCode,
//         identifier: email
//       };
      
//       // Verify email with code
//       await verifyEmail(body);
      
//       console.log('✅ Email verified successfully');
      
//       // Get updated user profile with email_verified: true
//       const userResponse = await getUserByToken();
//       const { user } = userResponse.data;
      
//       console.log('👤 Got updated user:', user);
      
//       // Fulfill user in Redux - this triggers dashboard redirect
//       dispatch(auth.actions.fulfillUser(user));
      
//       setStatus('Email verified successfully! Redirecting to dashboard...');
      
//       // Clear stored email
//       localStorage.removeItem('activation_email');
      
//     } catch (error) {
//       setLoading(false);
//       console.error('❌ Verification error:', error);
//       const message = error.response?.data?.message || 'Invalid verification code';
//       setStatus(message);
//     }
//   };

//   const handleResend = async () => {
//     setResending(true);
//     setStatus('');

//     try {
//       console.log('📧 Resending verification email to:', email);
      
//       await sendVerificationEmail();
      
//       setResending(false);
//       setStatus('Verification code resent successfully');
//       setCode(['', '', '', '', '', '']);
//       if (inputRefs.current[0]) {
//         inputRefs.current[0].focus();
//       }
      
//     } catch (error) {
//       setResending(false);
//       console.error('❌ Resend error:', error);
//       const message = error.response?.data?.message || 'Failed to resend code';
//       setStatus(message);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('activation_email');
//     dispatch(auth.actions.logout());
//     navigate('/auth/login');
//   };

//   return (
//     <div className="clean-login-card">
//       <div className="login-header">
//         <div className="verification-icon">
//           <Mail size={32} />
//         </div>
//         <h1 className="login-title">Verify Your Email</h1>
//         <p className="login-subtitle">
//           We've sent a 6-digit code to<br />
//           <strong>{email}</strong>
//         </p>
//       </div>

//       {status && (
//         <div className={`login-alert ${status.includes('success') ? 'success' : ''}`}>
//           {status}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="login-form">
//         {/* PIN Input */}
//         <div className="form-group">
//           <label className="form-label">Verification Code</label>
//           <div className="pin-inputs" onPaste={handlePaste}>
//             {code.map((digit, index) => (
//               <input
//                 key={index}
//                 ref={el => inputRefs.current[index] = el}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength={1}
//                 value={digit}
//                 onChange={(e) => handleCodeChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 className="pin-input"
//                 autoFocus={index === 0}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Submit */}
//         <button
//           type="submit"
//           disabled={loading || code.some(c => !c)}
//           className="submit-btn"
//         >
//           {loading ? (
//             <>
//               Verifying...
//               <span className="spinner"></span>
//             </>
//           ) : (
//             'Verify Email'
//           )}
//         </button>

//         {/* Resend Code */}
//         <div className="form-footer">
//           Didn't receive the code?{' '}
//           <button
//             type="button"
//             className="footer-link"
//             onClick={handleResend}
//             disabled={resending}
//           >
//             {resending ? 'Sending...' : 'Resend Code'}
//           </button>
//         </div>

//         {/* Logout */}
//         <button
//           type="button"
//           className="back-btn"
//           onClick={handleLogout}
//         >
//           <ArrowLeft size={16} />
//           Sign Out
//         </button>
//       </form>
//     </div>
//   );
// }

// export default injectIntl(Activation);


// src/app/modules/Auth/pages/Activation.jsx
import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { verifyEmail, sendVerificationEmail, getUserByToken, getUserOrganizations } from "../_redux/authCrud";
import './auth.scss';
import { Mail, ArrowLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

import { googleLogout } from '@react-oauth/google';


function Activation(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [status, setStatus] = useState('');
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  const { email } = location.state || {};

  useEffect(() => {
    if (!email) {
      console.log('❌ No email found, redirecting to login');
      navigate('/auth/login');
    } else {
      console.log('📧 Activation email:', email);
    }
  }, [email, navigate]);

  const handleCodeChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0 && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, 6);
    if (!/^\d+$/.test(pastedData)) return;

    const newCode = pastedData.split('');
    while (newCode.length < 6) newCode.push('');
    setCode(newCode);

    const nextEmptyIndex = newCode.findIndex(c => !c);
    const focusIndex = nextEmptyIndex === -1 ? 5 : nextEmptyIndex;
    if (inputRefs.current[focusIndex]) {
      inputRefs.current[focusIndex].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullCode = code.join('');

    if (fullCode.length !== 6) {
      setStatus('Please enter the complete 6-digit code');
      return;
    }

    setLoading(true);
    setStatus('');

    try {
      console.log('🔐 Verifying code:', fullCode);
      
      const body = {
        code: fullCode,
        identifier: email
      };
      
      // Verify email with code
      await verifyEmail(body);
      
      console.log('✅ Email verified successfully');
      
      // Get updated user profile with email_verified: true
      const userResponse = await getUserByToken();
      const { user } = userResponse.data;
      
      console.log('👤 Got updated user:', user);
      
      // Fulfill user in Redux
      dispatch(auth.actions.fulfillUser(user));
      
      // Clear stored email
      localStorage.removeItem('activation_email');
      
      // Fetch organizations and redirect accordingly
      try {
        const orgsResponse = await getUserOrganizations();
        const organizations = orgsResponse.data.organizations || [];
        
        dispatch(auth.actions.fulfillOrgs(organizations));
        
        setLoading(false);
        setStatus('Email verified successfully! Redirecting...');
        
        // Redirect based on organization status
        if (organizations.length === 0) {
          setTimeout(() => {
            navigate('/auth/organization-setup', { 
              state: { user, fromRegistration: true } 
            });
          }, 1000);
        } else {
          setTimeout(() => {
            navigate('/dashboard');
          }, 1000);
        }
      } catch (error) {
        // No organizations or error fetching
        dispatch(auth.actions.fulfillOrgs([]));
        setLoading(false);
        setStatus('Email verified successfully! Redirecting...');
        setTimeout(() => {
          navigate('/auth/organization-setup', { 
            state: { user, fromRegistration: true } 
          });
        }, 1000);
      }
      
    } catch (error) {
      setLoading(false);
      console.error('❌ Verification error:', error);
      const message = error.response?.data?.message || 'Invalid verification code';
      setStatus(message);
    }
  };

  const handleResend = async () => {
    setResending(true);
    setStatus('');

    try {
      console.log('📧 Resending verification email to:', email);
      
      await sendVerificationEmail();
      
      setResending(false);
      setStatus('Verification code resent successfully');
      setCode(['', '', '', '', '', '']);
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
      
    } catch (error) {
      setResending(false);
      console.error('❌ Resend error:', error);
      const message = error.response?.data?.message || 'Failed to resend code';
      setStatus(message);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('activation_email');
    dispatch(auth.actions.logout());
    googleLogout();
    navigate('/auth/login');
  };

  return (
    <div className="clean-login-card">
      <div className="login-header">
        <div className="verification-icon">
          <Mail size={32} />
        </div>
        <h1 className="login-title">Verify Your Email</h1>
        <p className="login-subtitle">
          We've sent a 6-digit code to<br />
          <strong>{email}</strong>
        </p>
      </div>

      {status && (
        <div className={`login-alert ${status.includes('success') ? 'success' : ''}`}>
          {status}
        </div>
      )}

      <form onSubmit={handleSubmit} className="login-form">
        {/* PIN Input */}
        <div className="form-group">
          <label className="form-label">Verification Code</label>
          <div className="pin-inputs" onPaste={handlePaste}>
            {code.map((digit, index) => (
              <input
                key={index}
                ref={el => inputRefs.current[index] = el}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleCodeChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="pin-input"
                autoFocus={index === 0}
              />
            ))}
          </div>
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={loading || code.some(c => !c)}
          className="submit-btn"
        >
          {loading ? (
            <>
              Verifying...
              <span className="spinner"></span>
            </>
          ) : (
            'Verify Email'
          )}
        </button>

        {/* Resend Code */}
        <div className="form-footer">
          Didn't receive the code?{' '}
          <button
            type="button"
            className="footer-link"
            onClick={handleResend}
            disabled={resending}
          >
            {resending ? 'Sending...' : 'Resend Code'}
          </button>
        </div>

        {/* Logout */}
        <button
          type="button"
          className="back-btn"
          onClick={handleLogout}
        >
          <ArrowLeft size={16} />
          Sign Out
        </button>
      </form>
    </div>
  );
}

export default injectIntl(Activation);